<template>
  <require-notice
    v-if="isMac"
    :header="__('macOS app required')"
    :body="
      __(
        '%{name} does not support %{feature}. But our macOS App does. Install it to enjoy audio, video, and screen recording.',
        { name: browserName, feature: feature },
      )
    "
    :action-text="__('Install')"
    :cancel-text="__('No thanks')"
    @action="install"
    @cancel="cancel"
  >
    <img src="../images/mac_banner@3x.png" />
  </require-notice>
  <require-notice
    v-else-if="isWindows"
    :header="__('Windows app required')"
    :body="
      __(
        '%{name} does not support %{feature}. But our Windows App does. Install it to enjoy audio, video, and screen recording.',
        { name: browserName, feature: feature },
      )
    "
    :action-text="__('Install')"
    :cancel-text="__('No thanks')"
    @action="install"
    @cancel="cancel"
  >
    <img src="../images/windows_banner@3x.png" />
  </require-notice>
  <require-notice
    v-else-if="isMobile"
    :header="__('Not supported')"
    :body="__('Sorry, this feature is only available on desktop devices.')"
    :cancel-text="__('Close')"
    @cancel="cancel"
  />
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import t from 'vuedirectives/t'
import IntlMixin from 'vuemixins/intl_mixin'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'
import RequireNotice from 'vuecomponents/require_notice.vue'
import { mapState } from 'vuex'

const MAC_APP_URL = 'http://sl.padlet.com/mac_app'
const WINDOWS_APP_URL = 'http://sl.padlet.com/windows_app'
export default {
  components: { RequireNotice },
  directives: { t },
  mixins: [IntlMixin, EscapeToCancelMixin],
  props: ['feature'],
  computed: {
    ...mapState(['isMac', 'isWindows', 'isMobile', 'isSafari', 'isIE', 'isEdge', 'isChrome']),
    browserName() {
      if (this.isSafari) {
        return 'Safari'
      }
      if (this.isIE) {
        return 'Internet Explorer'
      }
      if (this.isEdge) {
        return 'Edge'
      }
      if (this.isChrome) {
        return 'Chrome'
      }
      return 'Your browser'
    },
  },
  methods: {
    cancel() {
      this.$emit('close')
    },
    install() {
      if (this.isMac) {
        window.open(MAC_APP_URL, '_blank')
      } else if (this.isWindows) {
        window.open(WINDOWS_APP_URL, '_blank')
      }
      this.$emit('close')
    },
  },
}
</script>
